// @ts-ignore
import React, {useCallback} from "react";
import {resetContract} from "../../requests/er-thunk";
import {useAppDispatch} from "../../../core/hooks";
import {Button} from "../../../ui-components";
import {cancelCustomerBookings} from "../../requests/insurance-thunk";

const ResetModal = ({contract}) => {
  const dispatch = useAppDispatch()

  const handleResetContract = useCallback(
    () => {
      dispatch(resetContract({document_uuid: contract.uuid}))
    }, [dispatch, contract]
  );
  return <div>
    <p style={{marginTop: 20, marginBottom: 20, fontSize: 16}}>{contract?.comments}</p>
    <Button type='contained' fullWidth onClick={handleResetContract}>Да</Button>
  </div>
}

export default ResetModal
